// @ts-nocheck

  import SmileOutlined from '@ant-design/icons/es/icons/SmileOutlined';
import DashboardOutlined from '@ant-design/icons/es/icons/DashboardOutlined';
import UserOutlined from '@ant-design/icons/es/icons/UserOutlined'
  export default {
    SmileOutlined,
DashboardOutlined,
UserOutlined
  }